import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./SellStatsSection.css";

const SellStatsSection = ({ cmsData = [] }) => {
  // Early validation and default values
  if (!Array.isArray(cmsData)) {
    console.warn("HowItWorks: cmsData should be an array");
    cmsData = [];
  }
  // Safely access the data with fallbacks
  const hubzuCmsData = cmsData.length > 0 ? cmsData[0]?.statsSection || {} : {};

  const statsDetails = hubzuCmsData?.["@nodes"]
    ? hubzuCmsData?.["@nodes"].reduce((acc, node) => {
        if (hubzuCmsData?.[node]) {
          acc.push(hubzuCmsData[node]);
        }
        return acc;
      }, [])
    : [];

  return (
    <div
      className="stats-background"
      style={{
        backgroundImage: `url(${hubzuCmsData?.bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {statsDetails.length > 0 && (
        <Container className="d-flex justify-content-center align-items-center stats-container">
          <Card className="sell-stats-card">
            <Row className="g-3">
              {statsDetails.map((milestone, index) => (
                <Col
                  key={index}
                  xs={12}
                  sm={6}
                  md={4}
                  className="stats-col text-center"
                >
                  <h2 className="stats-number">{milestone.value}</h2>
                  <p className="stats-text">{milestone.text}</p>
                </Col>
              ))}
            </Row>
          </Card>
        </Container>
      )}
    </div>
  );
};

export default SellStatsSection;
